import React from "react";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, children, loginFromMobileApp }) {
  const handleFlutterLogoClick = () => {
    window.GameStatus.postMessage("navigate_back");
  };

  return (
    <>
      <header className="upperaction">
        {loginFromMobileApp ? (
          <button
            type="button"
            className="logo-header-flutter"
            onClick={handleFlutterLogoClick}
            aria-label="Back"
          >
            <img src={imageUrl} alt="Header" className="logo-holder" />
          </button>
        ) : (
          <a href={process.env.REACT_APP_BASE_URL}>
            <img src={imageUrl} alt="Header" className="logo-holder" />
          </a>
        )}
        {!loginFromMobileApp ? (
          <div className="back-holder">
            <button onClick={onBack} className="back-default">
              Back
            </button>
          </div>
        ) : null}
      </header>
      {children}
    </>
  );
}

export default DDDUI;